/**
 * 会社ロゴ表示コンポーネント。
 * 運営管理者が会社ごとに設定したロゴ（/api/branding）を表示し、
 * 未設定の会社では従来の UNISON ロゴにフォールバックする。
 * 体験デモ（test / test-kaisya）は会社ロゴの代わりに製品名「カツオ勤怠」のロゴを出す。
 * 取得結果は localStorage にキャッシュされるためオフラインでも表示できる。
 */
import React, { useEffect, useState } from 'react';
import { fetchBranding, getCachedBranding } from '../services/api';
import { isDemoHost } from '../utils/brand';

export const CompanyLogo: React.FC<{
  height?: number;
  /** 暗い背景に置く場合 true（会社ロゴは白チップで囲み、既定ロゴは白抜き表示） */
  dark?: boolean;
}> = ({ height = 26, dark = false }) => {
  const [logo, setLogo] = useState<string | null>(() => getCachedBranding()?.logo_url ?? null);

  useEffect(() => {
    let alive = true;
    fetchBranding().then(b => { if (alive && b) setLogo(b.logo_url ?? null); });
    return () => { alive = false; };
  }, []);

  if (isDemoHost()) {
    return (
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: Math.round(height * 0.2) }}>
        <img src="/katsuo-mascot.png" alt="" style={{ height: Math.round(height * 1.1), objectFit: 'contain' }} />
        <span style={{ fontSize: Math.round(height * 0.62), fontWeight: 800, lineHeight: 1, letterSpacing: '0.02em', color: dark ? '#ffffff' : '#1b2a3d' }}>
          カツオ<span style={{ color: dark ? '#93b9da' : '#2264c8' }}>勤怠</span>
        </span>
      </span>
    );
  }

  if (logo) {
    if (dark) {
      return (
        <span style={{ display: 'inline-flex', alignItems: 'center', background: 'rgba(255,255,255,0.94)', borderRadius: 10, padding: '6px 14px' }}>
          <img src={logo} alt="logo" style={{ height, objectFit: 'contain', maxWidth: 200 }} />
        </span>
      );
    }
    return <img src={logo} alt="logo" style={{ height, objectFit: 'contain', maxWidth: 200 }} />;
  }
  return (
    <img
      src="/unison-logo.png" alt="UNISON"
      style={{ height, objectFit: 'contain', ...(dark ? { filter: 'brightness(0) invert(1)' } : {}) }}
      onError={e => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
    />
  );
};

export default CompanyLogo;
